<template>
  <header id="header-main" class="header-main header-scroll" ref="header-main">
    <slot></slot>
  </header>
</template>

<script>
import { throttle } from 'lodash'
export default {
  name: 'FixedHeaderWrapper',
  components: {},
  props: {},
  data: () => {
    return {
      lastScrollTop: 0,
      lastDirection: 'down',
      intervalTimer: null,
      headerEl: null
    }
  },
  methods: {
    headerMoving (direction) {
      const scroll = window.pageYOffset
      const header = document.getElementById('header-main')
      if (direction === this.lastDirection && scroll !== 0) return
      if (scroll === 0 || direction === 'down') {
        header.classList.remove('open')
        header.classList.add('close')
      } else if (direction === 'up') {
        header.classList.remove('close')
        header.classList.add('open')
      }
    },
    scrollThrottleEvent: throttle(function () {
      let nextScrollTop = window.pageYOffset
      if (nextScrollTop < 0) {
        const header = document.getElementById('header-main')
        this.intervalTimer = setInterval(() => {
          if (window.pageYOffset === 0) {
            header.classList.remove('open')
            header.classList.add('close')
            clearInterval(this.intervalTimer)
          }
        }, 50)
        return
      }
      if (nextScrollTop > this.lastScrollTop) {
        this.headerMoving('down')
        this.lastDirection = 'down'
      } else if (nextScrollTop < this.lastScrollTop) {
        this.headerMoving('up')
        this.lastDirection = 'up'
      }
      this.lastScrollTop = nextScrollTop
    }, 100)
  },
  mounted () {
    window.addEventListener('scroll', this.scrollThrottleEvent)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollThrottleEvent)
  }
}
</script>
